import React, { useEffect, useRef } from 'react';
import LandingPage from '../../components/LandingPage/LandingPage';
import BoardPage from '../BoardPage/BoardPage';
import Sponsors from '../../components/Sponsors/Sponsors';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import Contact from '../../components/Contact/Contact';
import Footer from '../../components/Footer/Footer';
import { PageName } from '../../types';

interface HomePageProps {
  onNavigate: (page: PageName, section?: string) => void;
  scrollToSection?: string | null;
  onScrollComplete?: () => void;
}

function HomePage({ onNavigate, scrollToSection, onScrollComplete }: HomePageProps) {
  const aboutUsRef = useRef<HTMLDivElement>(null);

  // Handle scrolling to specified section
  useEffect(() => {
    if (scrollToSection) {
      const scrollToElement = (sectionId: string) => {
        let element = document.getElementById(sectionId);
        
        // Fallback to refs if element with ID is not found
        if (!element) {
          if (sectionId === 'about-us') {
            element = aboutUsRef.current;

          }
        }
        
        if (element) {
          const elementPosition = element.offsetTop;
          const offsetPosition = elementPosition - 80; // Account for any fixed header
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          // Call onScrollComplete after a delay to ensure scroll is finished
          setTimeout(() => {
            if (onScrollComplete) {
              onScrollComplete();
            }
          }, 1000);
        }
      };

      // Small delay to ensure the component is fully rendered
      setTimeout(() => {
        scrollToElement(scrollToSection);
      }, 100);
    }
  }, [scrollToSection, onScrollComplete]);

  return (
    <div className="min-h-screen flex flex-col">
      <LandingPage onNavigate={onNavigate} />
      <div ref={aboutUsRef}>
        <AboutUsPage />
      </div>
      <section id="board" className="py-12 px-4 bg-white">
        <BoardPage />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <section id="sponsors" className="py-12 px-4 bg-gray-100">
        <Sponsors />
      </section>
      <Footer />
    </div>
  );
}

export default HomePage;
